

class SerpUrl {
    constructor({
        validSortFields = ['Relevance', 'Price/asc', 'Price'],
        validCategories = ['shopping', 'web'],
        queryParam = 'q',
        categoryParam = 'cat',
        sortParam = 'sort',
        nfspParam = 'nfsp',
        pageParam = 'page'
    } = {}) {

        this.validSortFields = validSortFields;
        this.validCategories = validCategories;
        this.queryParam = queryParam;
        this.categoryParam = categoryParam;
        this.sortParam = sortParam;
        this.pageParam = pageParam;
        this.nfspParam = nfspParam;

        this.url = new URL(document.location);
        this.params = this.url.searchParams;

    }

    set sort(field = null) {
        if(this.validSortFields.includes(field)) {
            this.params.set(this.sortParam, field);
        } else {
            this.params.delete(this.sortParam);
        }
        
    }

    get sort() {
        return this.params.get(this.sortParam);
    }

    set category(category = null) {
        if(this.validCategories.includes(category)) {
            this.params.set(this.categoryParam, category);
        } else {
            this.params.delete(this.categoryParam);
        }
    }

    get category() {
        return this.params.get(this.categoryParam);
    }

    set cat(category) {
        this.category = category;
    }

    get cat() {
        return this.category;
    }

    set query(terms) {
        if(terms) {
            this.params.set(this.queryParam, terms);
        } else {
            this.params.delete(this.queryParam);
        }
    }

    get query() {
        return this.params.get(this.queryParam);
    }

    set q(terms) {
        this.query = terms;
    }

    get q() {
        return this.query;
    }

    set page(page) {
        if(page) {
            this.params.set(this.pageParam, page);
        } else {
            this.params.delete(this.pageParam);
        }
    }

    get page() {
        return this.params.get(this.pageParam);
    }

    set nfsp(nfsp) {
        if(nfsp) {
            this.params.set(this.nfspParam, nfsp);
        } else {
            this.params.delete(this.nfspParam);
        }
    }

    get nfsp() {
        return this.params.get(this.nfspParam);
    }

    set pathname(pathname) {
        this.url.pathname = pathname;
    }

    get pathname() {
        return this.url.pathname;
    }

    param(key, value) {
        const setter = Object.getOwnPropertyDescriptor(Object.getPrototypeOf(this), key);
        if(setter) {
            setter.set.call(this, value);
        } else {
            this.params.set(key, value);
        }

        return this;
    }

    go() {
        window.location.href = this.url.toString();
    }

    href() {
        return this.url.toString();
    }

    pathAndSearch() {
        return `${this.pathname}?${this.params.toString()}`;
    }


}


export default SerpUrl;

